import { Iso } from 'monocle-ts';

export const KopecksIso = new Iso<FeipApi.Kopecks, number>(
    (k) => k / 100,
    (n) => Math.floor(n * 100) as FeipApi.Kopecks,
);
